import VideoPageLoop from './video-page-loop';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import VideoPageMultiple from './video-page-multiple';
import VideoPageVideojs from './video-page-videojs';
import VideoPageHls from './video-page-hls';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export function App() {
  const [queryClient] = useState(() => new QueryClient());


  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-100">
          <Navbar />
          <Routes>
            <Route path="/multiple" element={<VideoPageMultiple />} />
            <Route path="/loop" element={<VideoPageLoop />} />
            <Route path="/videojs" element={<VideoPageVideojs />} />
            <Route path="/videohls" element={<VideoPageHls />} />
            <Route path="/company/:companyId" element={<VideoPageMultiple />} />
            <Route path="/company/:companyId/:videoId" element={<VideoPageHls />} />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
